<template>
    <div class="auth__validatekey_form">
        <div class="container">
            <div class="columns is-variable">
                <div class="column">
                    <div class="auth__validatekey_form_box">
                        <div class="auth__validatekey_form_box_fields">
                            <form-text
                                :label="'Enter your registration key'"
                                :name="'validatekey-key'"
                                :v-validate="{ required: true, min: 8, max: 8 }"
                                :data-vv-as="'key'"
                                v-model="key"
                                @emit-enter="handleValidateKey"
                            >To self-register you should have an 8 character key, enter this key in the field above and click Continue.
                            </form-text>
                        </div>
                        <transition name="fade" mode="out-in">
                            <template v-if="error">
                                <div class="auth__validatekey_form_box_error">
                                    <component-note :danger="true">{{ error }}</component-note>
                                </div>
                            </template>
                        </transition>
                        <div class="auth__validatekey_form_box_actions">
                            <component-button
                                ref="validatekeysubmit"
                                :theme="'primary'"
                                :size="'full'"
                                :animate-loading="true"
                                :animate-loading-event-name="'user-validatekey'"
                                :name="'auth-validatekey-form-box-actions-validatekey'"
                                @click="handleValidateKey"
                            >Continue
                            </component-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FormText from '@/components/default/forms/FormText'
import ComponentButton from '@/components/default/shared/ComponentButton'
import ComponentNote from '@/components/default/shared/ComponentNote'

export default {
  name: 'auth-validatekey-form',
  components: { ComponentNote, ComponentButton, FormText },
  data () {
    return {
      requestValidateKeyPending: true
    }
  },
  computed: {
    key: {
      get () {
        return this.$store.getters.getAuthUserValidateKeyKey
      },
      set (value) {
        this.$store.dispatch('authUserSetValidateKeyKey', value)
      }
    },
    error () {
      return this.$store.getters.getAuthUserValidateKeyError
    }
  },
  methods: {
    handleValidateKey () {
      this.$refs.validatekeysubmit.startLoading()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.performValidateKey(this.key)
        } else {
          this.$eventBus.$emit('stop-user-validatekey')
        }
      })
    },
    performValidateKey (data) {
      this.$store.dispatch('authUserValidateKey', data).then(response => {
        const apiActive = response.data.apiActive

        if (apiActive) {
          this.$eventBus.$emit('stop-user-validatekey')
          this.$store.dispatch('defaultNotificationToastsAdd', {
            title: 'Self-registration not available',
            message: ``,
            status: 'error'
          })
        } else {
          this.getWorkspaceCustomisation().then(response => {
            const workspaceId = response.id
            this.getWorkspaceCustomFields(workspaceId).then(() => {
              this.$router.push({ name: 'auth-self-registration', params: { key: this.key } })
            }).finally(() => {
              this.$eventBus.$emit('stop-user-validatekey')
            })
          })
        }
      }).catch(() => {
        this.$eventBus.$emit('stop-user-validatekey')
      })
    },
    getWorkspaceCustomisation () {
      return this.$store.dispatch('defaultWorkspaceGetCustomisation', this.key)
    },
    getWorkspaceCustomFields (data) {
      return this.$store.dispatch('lmsSuperadminCustomFieldsGet', data)
    }
  },
  provide () {
    return {
      $validator: this.$validator
    }
  },
  mounted () {
    const routeKey = this.$route.query.registerKey

    if (routeKey) {
      this.key = routeKey
      this.$refs.validatekeysubmit.startLoading()
      this.performValidateKey(routeKey)
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/auth/validatekey/authvalidatekeyform";
</style>
